import { useState } from 'react';
import { signIn } from '@/hooks/useAuth';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPass, setShowPass] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Preencha e-mail e senha.');
      return;
    }
    setLoading(true);
    try {
      const { error: err } = await signIn(email, password);
      if (err) {
        if (err.message.toLowerCase().includes('invalid') || err.message.toLowerCase().includes('credentials')) {
          setError('E-mail ou senha incorretos.');
        } else {
          setError(err.message);
        }
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center p-4 relative overflow-hidden">
      {/* Background decorativo */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-neon/5 blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 rounded-full bg-neon/3 blur-3xl"></div>
      </div>
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'linear-gradient(rgba(57,255,20,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(57,255,20,0.5) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }}
      ></div>

      <div className="relative w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-neon/10 border border-neon/20 mb-4">
            <i className="ri-store-3-fill text-neon text-2xl"></i>
          </div>
          <h1 className="text-2xl font-bold text-white tracking-tight">
            Piot<span className="text-neon">Fit</span>
          </h1>
          <p className="text-dark-muted text-sm mt-1">Sistema de Gestão Financeira</p>
        </div>

        {/* Card */}
        <div className="bg-dark-card border border-dark-border rounded-2xl p-6">
          <h2 className="text-base font-bold text-dark-text mb-5">Acesse sua conta</h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs text-dark-muted mb-1.5 block font-medium">E-mail</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-dark-muted text-sm"></i>
                </div>
                <input
                  type="email"
                  className="input-dark pl-9 text-sm"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </div>
            </div>

            <div>
              <label className="text-xs text-dark-muted mb-1.5 block font-medium">Senha</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                  <i className="ri-lock-line text-dark-muted text-sm"></i>
                </div>
                <input
                  type={showPass ? 'text' : 'password'}
                  className="input-dark pl-9 pr-10 text-sm"
                  placeholder="••••••••"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPass(s => !s)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-dark-muted hover:text-dark-text cursor-pointer"
                >
                  <i className={`${showPass ? 'ri-eye-off-line' : 'ri-eye-line'} text-sm`}></i>
                </button>
              </div>
            </div>

            {error && (
              <div className="flex items-center gap-2 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2.5">
                <div className="w-4 h-4 flex items-center justify-center shrink-0">
                  <i className="ri-error-warning-line text-red-400 text-sm"></i>
                </div>
                <p className="text-xs text-red-400">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn-gold w-full py-3 rounded-xl text-sm cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <div className="w-4 h-4 border-2 border-black/30 border-t-black rounded-full animate-spin"></div>
                  <span>Entrando...</span>
                </>
              ) : (
                <span>Entrar no sistema</span>
              )}
            </button>
          </form>
        </div>

        <p className="text-center text-[11px] text-dark-muted mt-5">
          PiotFit &copy; {new Date().getFullYear()} · Gestão inteligente para sua loja
        </p>
      </div>
    </div>
  );
}
